/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Textarea,
  Link
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Controller, useForm } from "react-hook-form";
// import Tags from '../common/Tags'
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import {
  addCourse,
  getCategories_new,
  getClasses_new,
  getCourses,
  getDegree,
  getSpecification,
  getCourse,
  updateCourse,
} from "../../redux/api_calls/apiCalls";
// import { ReactComponent as AddPhoto } from '../../svg/AddPhoto.svg'
import { ReactComponent as UploadIcon } from "../../svg/Upload.svg";

export default function CustomAddItems() {
  let { courseId } = useParams();

  const [degrees, setDegrees] = useState([]);
  const [specification, setSpecification] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [contentLink, setContentLink] = useState(null);

  const [files, setFiles] = useState([]);

  const useYupValidationResolver = (validationSchema) =>
    useCallback(
      async (data) => {
        try {
          const values = await validationSchema.validate(data, {
            abortEarly: false,
          });

          return {
            values,
            errors: {},
          };
        } catch (errors) {
          console.log(errors);
          console.log(errors.inner);
          return {
            values: {},
            errors: errors.inner.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path]: {
                  type: currentError.type ?? "validation",
                  message: currentError.message,
                },
              }),
              {}
            ),
          };
        }
      },
      [validationSchema]
    );

  const validationSchema = yup.object({
    category_id: yup.string().required("Category is required"),
    degree: yup.string().required("Degree is required"),
    class_id: yup.string().required("Class is required"),
    subject_id: yup.string().required("Subject is required"),
    title: yup.string().required("Title is required"),
    description: yup.string().required("Description is required"),
    status: yup.string().required(" is required"),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ resolver });

  const slider = useSelector((state) => state.sliderState.sliderOpen);
  const history = useHistory();

  let watchDegree = watch("degree");
  let watchCategory = watch("category_id");

  useEffect(() => {
    const loadFieldData = async () => {
      let courses = await getCourses();
      let degrees = await getDegree();
      let classes = await getClasses_new();
      let categories = await getCategories_new();
      setDegrees(degrees.data);
      setSubjects(courses);
      setClasses(classes);
      setCategories(categories);

      let courseData = await getCourse(courseId);
      console.log({ courseData });
      if (courseData) {
        for (let key of Object.keys(courseData)) {
          let fields = [
            "category_id",
            "degree",
            "specification",
            "class_id",
            "subject_id",
            "title",
            "description",
            "status",
          ];
          if (key && courseData[key] && fields.includes(key)) {
            setValue(key, courseData[key]);
          }
          console.log(key);
          if (key === "content_url") {
          console.log(courseData[key]);
            setContentLink(courseData[key]);
            console.log(contentLink);
          }
          console.log(contentLink);
        }
      }
    };

    loadFieldData();
  }, []);

  useEffect(() => {
    const loadSpecification = async () => {
      const token = JSON.parse(window.localStorage.getItem("user")).access_token;
        fetch("https://simplifyed.io/dev-api/class/api/tutor/getSpecifications/" + watchDegree, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function(response){ return response.json(); })
        .then(function(data) {
            const items = data;
            setSpecification(items.payload.data);
        })

    };

    if (watchDegree) {
      loadSpecification();
    }
  }, [watchDegree]);

  const onSubmit = async (values) => {
    let formData = new FormData();
    for (let key of Object.keys(values)) {
      formData.append(key, values[key]);
    }
    if (files.length > 0) {
      formData.append("presentation", files[0]);
    }

    formData.append("library_id", courseId);

    let res = await updateCourse(courseId, formData);
    if (res) {
      history.push("/courses");
    }
  };

  return (
    <Box
      flexGrow="1"
      d="flex"
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
      minH="90vh"
      pl={[
        "0",
        "0",
        "0",
        slider ? (window.innerWidth < 1400 ? "18vw" : "13vw") : "7.5vw",
      ]}
      transition="all 350ms ease"
    >
      <Box
        width={["95%", "95%", "90%", "85%"]}
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        alignItems={["center", "center", "flex-start", "flex-start"]}
        d="flex"
        mb="2rem"
        flexDirection="column"
      >
        <Text
          fontSize={["20px", "25px", "30px", "40px"]}
          d={["none", "none", "none", "flex"]}
          fontWeight="900"
          style={{ fontFamily: "Mulish, sans-serif" }}
          mb="2rem"
        >
          Edit Item
        </Text>
        <form style={{ width: "800px" }} onSubmit={handleSubmit(onSubmit)}>
          <Box
            width={["100%", "100%", "100%", "85%"]}
            justifyContent={["center", "center", "flex-start", "flex-start"]}
            alignItems={["center", "center", "flex-start", "flex-start"]}
            d="flex"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                width: "90%",
              }}
            >
              <FormControl
                isInvalid={errors.category_id && errors.category_id.message}
              >
               <FormLabel
                  variant="custom"
                  htmlFor="category"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Category
                </FormLabel>
                <Select
                   border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  width="100%"
                  bg="white"
                  {...register("category_id")}
                >
                  <option value="" disabled selected hidden>
                    Select Category
                  </option>
                  {categories.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.category_id && errors.category_id.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors.degree && errors.degree.message}>
                 <FormLabel
                  variant="custom"
                  htmlFor="degree"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Degree
                </FormLabel>
                <Select
                   border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  width="100%"
                  bg="white"
                  {...register("degree")}
                >
                  <option value="" disabled selected hidden>
                    Select Degree
                  </option>
                  {degrees=== null ?
                      <option></option>
                    :
                   degrees.map((item, idx) => <option value={item.id} key={idx}>{item.name}</option>)
                    }
                 
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.degree && errors.degree.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={errors.specification && errors.specification.message}
              >
               <FormLabel
                  variant="custom"
                  htmlFor="Specification"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Specification
                </FormLabel>
                <Select
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  width="100%"
                  bg="white"
                  {...register("specification")}
                >
                  <option value="" disabled selected hidden>
                    Select Specification
                  </option>
                  {specification!==undefined &&
                  specification.length!==0 && 
                     specification.map((item, idx) => <option value={item.id} key={idx}>{item.name}</option>)
                    }
                 
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.specification && errors.specification.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={errors.class_id && errors.class_id.message}
              >
               <FormLabel
                  variant="custom"
                  htmlFor="Year"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Year
                </FormLabel>
                <Select
                   border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  width="100%"
                  bg="white"
                  {...register("class_id")}
                >
                  <option value="" disabled selected hidden>
                    Select Class
                  </option>
                  {classes.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.class_id && errors.class_id.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={errors.subject_id && errors.subject_id.message}
              >
              <FormLabel
                  variant="custom"
                  htmlFor="Subject"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Subject
                </FormLabel>
                <Select
                   border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  width="100%"
                  bg="white"
                  {...register("subject_id")}
                >
                  <option value="" disabled selected hidden>
                    Select Subject
                  </option>
                  {subjects.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.subject_id && errors.subject_id.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors.title && errors.title.message}>
                <FormLabel
                  variant="custom"
                  htmlFor="topic_name"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Topic Title
                </FormLabel>
                <Input
                  width="100%"
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  bgColor="white"
                  {...register("title")}
                />
                <FormErrorMessage fontSize="sm">
                  {errors.title && errors.title.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={errors.description && errors.description.message}
              >
                <FormLabel
                  variant="custom"
                  fontSize={["14px", "16px", "18px"]}
                  htmlFor="quiz_description"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Item Description
                </FormLabel>
                <Textarea
                  id="quiz_description"
                  width="100%"
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  bgColor="white"
                  rows="6"
                  resize="vertical"
                  {...register("description")}
                />
                <FormErrorMessage fontSize="sm">
                  {errors.description && errors.description.message}
                </FormErrorMessage>
              </FormControl>

              <Dropzone
                // accept="video/*, audio/*, application/*, text/plain"
                onDrop={(acceptedFiles) => setFiles(acceptedFiles)}
                multiple
              >
                {({
                  getRootProps,
                  getInputProps,
                  isDragReject,
                  fileRejections,
                  acceptedFiles,
                }) => (
                  <Box>
                    <Box
                      {...getRootProps({ className: "dropzone" })}
                      d="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDir="column"
                      width="620px"
                      height=""
                      p="1rem"
                      backgroundColor="white"
                      borderRadius="16px"
                      border={
                        isDragReject
                          ? "2px dashed rgba(255, 0, 0, 0.5)"
                          : "2px dashed rgba(0, 0, 0, 0.1)"
                      }
                    >
                      <input {...getInputProps()} />
                      <UploadIcon />
                      <Text
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="700"
                        fontSize={["10px", "14px", "16px", "18px"]}
                        color="#666666"
                        m={["0.5rem", "0.75rem", "1rem", "1rem"]}
                      >
                        Drag & Drop{" "}
                        {watchCategory
                          ? categories.filter(
                              (e) => e.id === watchCategory
                            )[0] &&
                            categories.filter((e) => e.id === watchCategory)[0]
                              .name
                          : ""}
                      </Text>
                      <Text
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="600"
                        fontSize={["10px", "11px", "12px", "14px"]}
                        color="#666666"
                        mb={["0.5rem", "0.75rem", "1rem", "1rem"]}
                      >
                        OR
                      </Text>
                      <Button
                        bgColor="#8dc099"
                        color="white"
                        borderRadius="lg"
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        _hover={{ bg: "#7eac88" }}
                      >
                        Browse Files
                      </Button>
                    </Box>
                    {/* <aside style={{ paddingTop: "1rem", paddingLeft: "2rem" }}>
                      {fileRejections && (
                        <ul style={{ color: "red" }}>{fileRejections}</ul>
                      )}
                    </aside> */}
                    <aside style={{ paddingTop: "1rem", paddingLeft: "2rem" }}>
                      {acceptedFiles &&
                        acceptedFiles.map((e) => <ul>{e.name}</ul>)}
                    </aside>
                    <aside style={{ paddingTop: "1rem", paddingLeft: "2rem" }}>
                      <ul style={{ color: "red" }}>
                        {errors.presentation && errors.presentation.message}
                      </ul>
                    </aside>
                    {contentLink && contentLink != "" ? (
                      <Box pl="2rem">
                        <FormLabel
                          variant="custom"
                          fontSize="16px"
                          style={{ fontFamily: "Mulish, sans-serif" }}
                        >
                          Uploaded Study Material (Click filename to Open) -{" "}
                        </FormLabel>
                           <Link
                            href={contentLink}
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            {contentLink.substring(
                              contentLink.lastIndexOf("/") + 11
                            )}
                          </Link>
                       </Box>
                    ) : (
                      <></>
                    )}
                  </Box>
                )}
              </Dropzone>
              

              {/* <Dropzone
              ref={dropzoneRef}
              noClick
              noKeyboard
              accept={
                "video/mp4, video/mpeg, video/ogg, video/quicktime, video/webm, video/x-m4v, video/x-msvideo, video/x-ms-wmv, audio/mpeg, audio/mp4, audio/ogg, audio/vnd.wav, audio/vorbis, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, text/plain, "
              }
              onDrop={dropHandler}
            >
              {({
                getRootProps,
                getInputProps,
                acceptedFiles,
                fileRejections,
              }) => {
                const fileRejectionItems = fileRejections.map(({ errors }) =>
                  errors.map((e) => (
                    <li key={e.code}>{"Unsupported File Type!"}</li>
                  ))
                );

                return (
                  <Box>
                    <Box
                      {...getRootProps({ className: "dropzone" })}
                      d="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDir="column"
                      width={["100%", "100%", "90%", "85%"]}
                      height=""
                      p="1rem"
                      backgroundColor="white"
                      borderRadius="16px"
                      border="2px dashed rgba(0, 0, 0, 0.1)"
                    >
                      <input {...getInputProps()} />
                      <UploadIcon />
                      <Text
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="700"
                        fontSize={["10px", "14px", "16px", "18px"]}
                        color="#666666"
                        m={["0.5rem", "0.75rem", "1rem", "1rem"]}
                      >
                        Drag & Drop Document / Video / Presentation
                      </Text>
                      <Text
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="600"
                        fontSize={["10px", "11px", "12px", "14px"]}
                        color="#666666"
                        mb={["0.5rem", "0.75rem", "1rem", "1rem"]}
                      >
                        OR
                      </Text>
                      <Button
                        bgColor="#8dc099"
                        color="white"
                        borderRadius="lg"
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        _hover={{ bg: "#7eac88" }}
                        onClick={openDialog}
                      >
                        Browse Files
                      </Button>
                    </Box>
                    <aside style={{ paddingTop: "1rem", paddingLeft: "2rem" }}>
                      {fileRejectionItems && (
                        <ul style={{ color: "red" }}>{fileRejectionItems}</ul>
                      )}
                    </aside>
                  </Box>
                );
              }}
            </Dropzone>
            {files.length > 0 && !editState.flag && (
              <Box
                pl="2rem"
                style={{ fontFamily: "Mulish, sans-serif" }}
                fontSize="16px"
                color="#666666"
              >
                <li>
                  {files[0].path} - {(files[0].size / (1024 * 1024)).toFixed(2)}{" "}
                  MB
                </li>
              </Box>
            )} */}

              

              <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <FormControl>
                  <FormLabel>Item Status</FormLabel>
                  <Controller
                    render={({ field }) => (
                      <RadioGroup
                        {...field}
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        color="#666666"
                        fontWeight="600"
                        fontSize="16px"
                      >
                        <Stack direction="row" spacing={8}>
                          <Radio value="Y">Enable</Radio>
                          <Radio value="N">Disable</Radio>
                        </Stack>
                      </RadioGroup>
                    )}
                    defaultValue="Y"
                    name="status"
                    control={control}
                  />
                </FormControl>
              </Box>

              <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                flexDir={["column", "column", "row", "row"]}
                justifyContent={[
                  "center",
                  "center",
                  "flex-start",
                  "flex-start",
                ]}
                mt="2rem"
              >
                <Button
                  bgColor="#429fff"
                  color="white"
                  borderRadius="lg"
                  p={["6px 15px", "8px 20px", "12px 30px"]}
                  _hover={{ bg: "#3b8fe4" }}
                  loadingText="Adding..."
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontWeight="800"
                  fontSize={["13px", "14px", "16px"]}
                  mr={["0", "0", "20px", "20px"]}
                  mb={["20px", "20px", "0", "0"]}
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                  type="submit"
                >
                  Edit Item
                </Button>
                <Button
                  bgColor="white"
                  color="#999999"
                  borderRadius="lg"
                  border="1px solid rgba(0, 0, 0, 0.2)"
                  p={["6px 15px", "8px 20px", "12px 30px"]}
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontWeight="800"
                  fontSize={["13px", "14px", "16px"]}
                  disabled={isSubmitting}
                  onClick={() => history.push("/courses")}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
}
